var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconsFilterFitnessPlayerLevel = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ffa589c6-ab50-42ff-9b79-c857e64a6d9f",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73,11.26C1.69,11.26,.03,12.92,.03,14.97s1.66,3.7,3.7,3.7,3.7-1.66,3.7-3.7-1.66-3.7-3.7-3.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,11.3c-2.04,0-3.7,1.66-3.7,3.7s1.66,3.7,3.7,3.7,3.7-1.66,3.7-3.7-1.66-3.7-3.7-3.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.26,11.26c-2.04,0-3.7,1.66-3.7,3.7s1.66,3.7,3.7,3.7,3.7-1.66,3.7-3.7-1.66-3.7-3.7-3.7Z",
    style: {
      opacity: 0.4
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsFilterFitnessPlayerLevel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icons_Filter_FitnessPlayer_Level.1551d6b3.svg";
export { ForwardRef as ReactComponent };